import React from "react";
import "../../styles/components/marketplace-shared.css";

const SummaryMetricCard = ({ label, value, className = "" }) => (
  <div className={`marketplace-summary-card ${className}`.trim()}>
    <span className="marketplace-summary-card__label">{label}</span>
    <strong className="marketplace-summary-card__value">{value}</strong>
  </div>
);

export default SummaryMetricCard;


